import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { APP_ROUTES } from '@core/constants';
import { AlertService, AuthService } from '@core/services';
import { getResetCtx } from '@core/utils';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordGuard {
  constructor(private router: Router, private alerts: AlertService) {}

  canActivate(): boolean | UrlTree {
    const identifier = getResetCtx();
    if (identifier) {
      return true;
    }

    this.alerts.setAlertOnNavigate(APP_ROUTES.FORGOT_PASSWORD, {
      message: 'Your reset session expired. Please start again.',
      type: 'warning'
    });
    return this.router.createUrlTree([APP_ROUTES.FORGOT_PASSWORD]);
  }
}
